import React from "react";
import { INTERNAL_CART_SOURCE } from "@cart-client/interfaces/Cart";

export interface CartFlowState {
    cartSource: INTERNAL_CART_SOURCE;
}

export interface CartFlowContextValue {
    data: CartFlowState;
    setData: React.Dispatch<React.SetStateAction<CartFlowState>>;
}

export const CartFlowContext = React.createContext<CartFlowContextValue>({
    data: {
        cartSource: INTERNAL_CART_SOURCE.DEFAULT_FOOD,
    },
    setData: () => {
        // do nothing
    },
});

if (__DEV__) {
    CartFlowContext.displayName = "CartFlowContext";
}
